"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Components = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _constant = require("../../../styles/constant");
var _templateObject, _templateObject2;
const DefaultFooter = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  justify-content: space-between;\n"])));
const Wrapper = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  justify-content: space-between;\n  padding: ", " ", " ", ";\n  border-top: 1px solid ", ";\n"])), (0, _constant.get)('space.15'), (0, _constant.get)('space.10'), (0, _constant.get)('space.10'), (0, _constant.get)('colors.functional.grey.400'));
const Components = exports.Components = {
  DefaultFooter,
  Wrapper
};